module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Incoming-box-8e37004916d9e35dec084c621de0c09d.svg";